class BaseModalBtnClass extends HTMLElement {
    // 组件属性
    attributes = {
        btn_label: '按钮',
        btn_class: '',
        btn_disabled: false,
        modal_title: '设置',
        modal_class: ''
    }

    // 按钮样式class
    btn_class = '';

    // 弹窗头部内容
    modal_title_html = '';

    // 弹窗主体内容
    modal_body_html = '';

    // 弹窗底部内容
    modal_footer_html = '';

    // 是否禁止点击
    _click_block = false;

    // 是否禁止弹窗
    _modal_block = false;

    // 弹窗蒙版是否透明
    _modal_mask_transparent = false;

    constructor() {
        super();
    }

    // 组件首次被插入文档DOM时调用的方法
    connectedCallback() {
        this.initAttributes();
        this.initHtml();

        this.innerHTML = globalCss + this.getBtnTemplate();
        this.querySelector('.' + this.btn_class).addEventListener('click', this.showModal.bind(this, this.loadAdditionalScript.bind(this)));
    }

    // 设置监听的属性
    static get observedAttributes() {
        return ['ar-btn-disabled', 'ar-get-data-url'];
    }

    // 监听属性更新触发事件
    attributeChangedCallback(key) {
        if (key === 'ar-btn-disabled') {
            if (this.getAttribute('ar-btn-disabled')) {
                this.attributes.btn_disabled = true;
                if (this.querySelector('button')) {
                    this.querySelector('button').setAttribute('disabled', 'disabled')
                }
            } else {
                this.attributes.btn_disabled = false;
                if (this.querySelector('button')) {
                    this.querySelector('button').removeAttribute('disabled')
                }
            }
        } else if (key === 'ar-get-data-url') {
            this.refresh()
        }
    }

    initHtml() {
        this.clearNotify();
        this.setModalTitleHtml(this.attributes.modal_title);
        this.setModalBodyHtml(this.getBtnModalBodyHtml());
        this.setModalFooterHtml(this.getBtnModalFooterHtml());
    }

    initAttributes() {
        for (let item in this.attributes) {
            let key = 'ar-' + item.replaceAll('_', '-');
            if (this.getAttribute(key)) {
                this.attributes[item] = this.getAttribute(key);
            }
        }
    }

    getModalTitleHtml() {
        return this.modal_title_html;
    }

    setModalTitleHtml(title) {
        this.modal_title_html = title;
    }

    getModalBodyHtml() {
        return this.modal_body_html;
    }

    setModalBodyHtml(body) {
        this.modal_body_html = body;
    }

    getModalFooterHtml() {
        return this.modal_footer_html;
    }

    setModalFooterHtml(footer) {
        this.modal_footer_html = footer;
    }

    getBtnModalBodyHtml() {
        return '';
    }

    getBtnModalFooterHtml() {
        return '';
    }

    loadAdditionalScript() {
    }

    getCookie(name) {
        const match = document.cookie
            .split('; ')
            .find(row => row.startsWith(`tipdm-race-web=`));
        return match ? match.split('=')[1] : null;
    }

    clearNotify() {
        document.querySelectorAll("div.ar-notify").forEach(function(item) {
            item.remove();
        });
    }

    blockClick() {
        this._click_block = true;
    }

    blockModal() {
        this._modal_block = true;
    }

    refresh() {
        this.initAttributes();
        this.querySelector('.ar-modal-body').innerHTML = this.getModalBodyHtml()
        this.querySelector('.ar-modal-footer').innerHTML = this.getModalFooterHtml()
        this.initHtml();
        let cancelBtn = this.querySelector(".ar-modal-footer .ar-cancel-btn");
        if (cancelBtn) {
            cancelBtn.addEventListener('click', (e) => {
                this.querySelector('.ar-modal').style.display = "none";
            });
        }
        this.loadAdditionalScript();
    }

    getBtnTemplate() {
        let disabled = '';
        if (this.attributes.btn_disabled) {
            disabled = ' disabled="disabled"'
        }

        return `
        <button type="button" class="ar-btn ` + this.btn_class + ` ` + this.attributes.btn_class + `"` + disabled + `>
            <span>` + this.attributes.btn_label + `</span>
        </button>
        `;
    }

    getModalTemplate(title, body, footer, ModalClass) {
        return `
        <div class="ar-modal ` + ModalClass + `">
            <div class="ar-modal-content">
                <div class="ar-modal-header">
                    <span class="ar-modal-title">` + title + `</span>
                    <span class="ar-close-btn">×</span>
                </div>
                <div class="ar-modal-body">
                    ` + body + `
                </div>
                <div class="ar-modal-footer">
                    ` + footer + `
                </div>
            </div>
        </div>
        `;
    }

    showModal(loadScript, obj) {
        if (this._modal_block) {
            if (obj) {
                loadScript();
            }
            return;
        }

        if (this._click_block) {
            this._click_block = false;
            return;
        }

        let self = this;
        let modal = self.querySelector(".ar-modal");

        if (modal) {
            modal.remove();
        }

        self.insertAdjacentHTML('beforeend', self.getModalTemplate(
            this.getModalTitleHtml(),
            this.getModalBodyHtml(),
            this.getModalFooterHtml(),
            this.attributes.modal_class
        ));
        modal = self.querySelector(".ar-modal");

        if (this._modal_mask_transparent) {
            modal.style.backgroundColor = 'transparent';
        }

        let modalBox = {};
        modalBox.modal = modal;
        modalBox.closeBtn = modal.querySelector(".ar-close-btn");
        modalBox.cancelBtn = modal.querySelector(".ar-cancel-btn");

        modalBox.show = function() {
            this.modal.style.display = "block";
        }

        modalBox.close = function() {
            this.modal.style.display = "none";
            self.initHtml();
        }

        modalBox.outsideClick = function(event) {
            if(event.target == this.modal) {
                this.close();
            }
        }

        modalBox.init = function() {
            this.show();
            this.closeBtn.addEventListener('click', this.close.bind(this));
            this.modal.addEventListener('click', this.outsideClick.bind(this));

            if (this.cancelBtn) {
                this.cancelBtn.addEventListener('click', this.close.bind(this));
            }
        }
        modalBox.init();

        let modalContent = modal.querySelector('.ar-modal-content');
        let modalHeader = modalContent.querySelector('.ar-modal-header');
        let offsetLeft = modalContent.offsetLeft;
        let offsetTop = 80; // 这个跟modal的margin-top有关
        let isDragging = false;
        let offsetX, offsetY;

        modalHeader.addEventListener('mousedown', (e) => {
            isDragging = true;
            offsetX = e.clientX - modalContent.offsetLeft + offsetLeft;
            offsetY = e.clientY - modalContent.offsetTop + offsetTop;
        });

        document.addEventListener('mousemove', (e) => {
            if (isDragging) {
                modalContent.style.left = e.clientX - offsetX + 'px';
                modalContent.style.top = e.clientY - offsetY + 'px';
            }
        });

        document.addEventListener('mouseup', () => {
            isDragging = false;
        });

        if (obj) {
            loadScript();
        }
    }

    getRuleSetFormHtml(withNameForm = false) {
        let url = window.aiReviewConfig.apiService.host + '/api/dict/data/public/list?dictType=model_list';

        return fetch(url, {}).then(res => {
            return res.json();
        }).then(data => {
            let keyUrl = window.aiReviewConfig.apiService.host + '/api/dict/data/public/list?dictType=dm_application_available_key';

            return fetch(keyUrl, {}).then(keyRes => {
                return keyRes.json();
            }).then(keyData => {
                let optStr = '';
                data.data.forEach(function (item) {
                    optStr += '<option value="' + item.dictValue + '">' + item.dictLabel + '</option>';
                });

                let keyStr = '';
                keyData.data.forEach(function (item) {
                    keyStr += '<p>' + item.dictValue + ' ' + item.dictLabel + '</p>';
                });

                let nameFormStr = ''
                if (withNameForm) {
                    nameFormStr += `
                    <div class="ar-form-item">
                        <div class="ar-form-label"><label class="ar-form-label-require">名称</label></div>
                        <div class="ar-form-content">
                            <input type="text" name="ar-name" id="ar-name" class="ar-form-control" placeholder="请输入应用名称" maxlength="30" />
                            <p class="ar-form-item-error-text"></p>
                        </div>
                    </div>
                    `;
                }

                return `
                <div class="ar-form-group">
                    ` + nameFormStr + `
                    <div class="ar-form-item">
                        <div class="ar-form-label"><label class="ar-form-label-require">提示词</label></div>
                        <div class="ar-form-content">
                            <textarea name="ar-prompt" id="ar-prompt" class="ar-form-control" style="height: 200px; resize: vertical" placeholder="请输入评阅要求。评阅至少需要输入{{stem}}题干和{{candidate_answer}}考生答案文本，输出{{score}}评分" maxlength="1000"></textarea>
                            <p class="ar-form-item-error-text"></p>
                            <div>
                                <span>可以使用变量占位符，动态替换占位符部分的内容。可用的变量请查看</span>
                                <div class="ar-tooltip">
                                    <div class="ar-tooltip-trigger" id="prompt-tooltip"> 变量说明 </div>
                                    <div class="ar-tooltip-box" id="prompt-tooltip-box">` + keyStr + `</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ar-form-item">
                        <div class="ar-form-label"><label class="ar-form-label-require">模型</label></div>
                        <div class="ar-form-content">
                            <div class="ar-rule-set-selector">
                                <select name="ar-model" id="ar-model" class="ar-form-control">
                                    <option value="">请选择</option>
                                    ` + optStr + `
                                </select>
                            </div>
                            <p class="ar-form-item-error-text"></p>
                        </div>
                    </div>
                    <div class="ar-form-item">
                        <div class="ar-form-label"><label class="ar-form-label-require">温度</label></div>
                        <div class="ar-form-content">
                            <input name="ar-temperature" id="ar-temperature" class="ar-form-control" type="text" autocomplete="off" style="width: 50px;margin-right: 20px">
                            <span>0 - 1 之间的数字，控制生成文本的多样性，数值越大生成的文本越具有创造性和多样性</span>
                            <p class="ar-form-item-error-text"></p>
                        </div>
                    </div>
                </div>
                `;
            });
        });
    }

    getRuleSetHtml() {
        let url = window.aiReviewConfig.apiService.host + '/api/application/public/' + window.aiReviewConfig.apiService.mark;

        return fetch(url, {}).then(res => {
            return res.json();
        }).then(data => {
            let optStr = '';
            let contentStr = '';
            data.data.forEach(function (item) {
                optStr += '<option value="' + item.id + '">' + item.name + '</option>';
                contentStr += `
                <div class="ar-form-group" id="ar-rule-content-` + item.id + `">
                    <div class="ar-form-item">
                        <div class="ar-form-label"><label>名称</label></div>
                        <div class="ar-form-content">
                            <div class="ar-form-content-text">` + item.name + `</div>
                            <p class="ar-form-item-error-text"></p>
                        </div>
                    </div>
                    <div class="ar-form-item">
                        <div class="ar-form-label"><label>提示词</label></div>
                        <div class="ar-form-content">
                            <div class="ar-form-content-text">` + item.prompt.replace(/\n/gm,"<br/>") + `</div>
                            <p class="ar-form-item-error-text"></p>
                        </div>
                    </div>
                    <div class="ar-form-item">
                        <div class="ar-form-label"><label>模型</label></div>
                        <div class="ar-form-content">
                            <div class="ar-form-content-text">` + item.model + `</div>
                            <p class="ar-form-item-error-text"></p>
                        </div>
                    </div>
                    <div class="ar-form-item">
                        <div class="ar-form-label"><label>温度</label></div>
                        <div class="ar-form-content">
                            <div class="ar-form-content-text">` + item.temperature + `</div>
                            <p class="ar-form-item-error-text"></p>
                        </div>
                    </div>
                </div>
                `;
            });

            return `
            <div id="ar-rule-batch-set-title">
                <div class="ar-form-group">
                    <div class="ar-form-item">
                        <div class="ar-form-label">
                            <label for="name">名称</label>
                        </div>
                        <div class="ar-form-content">
                            <div class="ar-rule-set-selector">
                                <select id="review-rule" class="ar-form-control">
                                    <option value="" data-prompt="" selected="selected">请选择</option>
                                    ` + optStr + `
                                    <!--<option value="customize">自定义</option>-->
                                </select>
                            </div>
                            <button type="button" id="ar-add-rule-btn" class="ar-btn ar-btn-primary is-plain">新增AI评阅应用</button>
                            <p class="ar-form-item-error-text"></p>
                        </div>
                    </div>
                </div>
                <input type="hidden" id="ar-rule-set-submit-type" name="ar-rule-set-submit-type" value="rule_id">
            </div>
            <div id="ar-rule-batch-set-content" class="hide">` + contentStr + `</div>
            `;
        })
    }

    notify(type, message, duration = 3000, title = '') {
        function getIcon(type) {
            let icon = document.createElementNS("http://www.w3.org/2000/svg","svg");
            icon.setAttribute("viewBox","0 0 1024 1024");
            icon.setAttribute("width", 24);
            icon.setAttribute("height", 24);

            var darkBlue = "#5BC0DE";
            var darkGreen = "#5CB85C";
            var darkOrange = "#F0AD4E";
            var darkRed = "#D9534F";

            let path1, path2, path3;

            switch (type) {
                case 'success':
                    path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    path1.setAttribute("d","M512 76.8c-236.8 0-435.2 192-435.2 435.2s192 435.2 435.2 435.2 435.2-192 435.2-435.2S748.8 76.8 512 76.8z m249.6 320L480 704c-12.8 12.8-38.4 12.8-51.2 0L288 556.8c-12.8-12.8-12.8-38.4 0-51.2 12.8-12.8 38.4-12.8 51.2 0l115.2 115.2L704 339.2c12.8-12.8 38.4-12.8 51.2 0 25.6 12.8 25.6 38.4 6.4 57.6z");
                    path1.setAttribute("fill",darkGreen);
                    icon.appendChild(path1);

                    path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    path2.setAttribute("d","M710.4 339.2l-256 281.6-115.2-115.2c-12.8-12.8-38.4-12.8-51.2 0-12.8 12.8-12.8 38.4 0 51.2l147.2 140.8c12.8 12.8 38.4 12.8 51.2 0L768 390.4c12.8-12.8 12.8-38.4 0-51.2-19.2-12.8-44.8-12.8-57.6 0z");
                    path2.setAttribute("fill","#FFFFFF");
                    icon.appendChild(path2);
                    break;
                case 'info':
                    path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    path1.setAttribute("d","M512 524.8m-416 0a416 416 0 1 0 832 0 416 416 0 1 0-832 0Z");
                    path1.setAttribute("fill", darkBlue);
                    icon.appendChild(path1);

                    path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    path2.setAttribute("d","M512 435.2c-19.2 0-38.4 19.2-38.4 38.4V768c0 19.2 19.2 38.4 38.4 38.4s38.4-19.2 38.4-38.4V473.6c0-19.2-19.2-38.4-38.4-38.4z");
                    path2.setAttribute("fill","#FFFFFF");
                    icon.appendChild(path2);

                    path3 = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    path3.setAttribute("d","M512 300.8m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z");
                    path3.setAttribute("fill","#FFFFFF");
                    icon.appendChild(path3);
                    break;
                case 'warning':
                    path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    path1.setAttribute("d","M512 512m-403.2 0a403.2 403.2 0 1 0 806.4 0 403.2 403.2 0 1 0-806.4 0Z");
                    path1.setAttribute("fill",darkOrange);
                    icon.appendChild(path1);

                    path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    path2.setAttribute("d","M512 608c-19.2 0-38.4-19.2-38.4-38.4V288c0-19.2 19.2-38.4 38.4-38.4s38.4 19.2 38.4 38.4V576c0 12.8-19.2 32-38.4 32z");
                    path2.setAttribute("fill","#FFFFFF");
                    icon.appendChild(path2);

                    path3 = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    path3.setAttribute("d","M512 736m-44.8 0a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0Z");
                    path3.setAttribute("fill","#FFFFFF");
                    icon.appendChild(path3);
                    break;
                case 'error':
                    path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    path1.setAttribute("d","M512 512m-435.2 0a435.2 435.2 0 1 0 870.4 0 435.2 435.2 0 1 0-870.4 0Z");
                    path1.setAttribute("fill",darkRed);
                    icon.appendChild(path1);

                    path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    path2.setAttribute("d","M563.2 512l108.8-108.8c12.8-12.8 12.8-38.4 0-51.2-12.8-12.8-38.4-12.8-51.2 0L512 460.8 403.2 352c-12.8-12.8-38.4-12.8-51.2 0-12.8 12.8-12.8 38.4 0 51.2L460.8 512 352 620.8c-12.8 12.8-12.8 38.4 0 51.2 12.8 12.8 38.4 12.8 51.2 0L512 563.2l108.8 108.8c12.8 12.8 38.4 12.8 51.2 0 12.8-12.8 12.8-38.4 0-51.2L563.2 512z");
                    path2.setAttribute("fill","#FFFFFF");
                    icon.appendChild(path2);
                    break;
            }

            icon.style.verticalAlign = "middle";
            return icon;
        }

        let notifyTypes = ['info', 'warning', 'error', 'success'];
        if (!notifyTypes.includes(type)) {
            type = 'info';
        }

        let notifyType = 'ar-notify-' + type;

        let icon = getIcon(type);

        let arNotify = document.createElement('div');
        arNotify.classList.add('ar-notify');

        let arNotifyContent = document.createElement('div');
        arNotifyContent.classList.add('ar-notify-content');

        let arNotifyHeader = document.createElement('div');
        arNotifyHeader.classList.add('ar-notify-header');

        let arNotifyTitle = document.createElement('span');
        arNotifyTitle.classList.add('ar-notify-title');
        arNotifyTitle.textContent = title;

        let arCloseBtn = document.createElement('span');
        arCloseBtn.classList.add('ar-close-btn');
        arCloseBtn.textContent = '×';

        let arNotifyBody = document.createElement('div');
        arNotifyBody.classList.add('ar-notify-body');

        let arNotifyMessage = document.createElement('span');
        arNotifyMessage.classList.add('ar-notify-message');
        arNotifyMessage.textContent = message;

        let arNotifyIcon = document.createElement('span');
        arNotifyIcon.classList.add('ar-notify-icon');
        arNotifyIcon.classList.add(notifyType);

        arNotifyIcon.appendChild(icon);

        if (title) {
            arNotifyHeader.appendChild(arNotifyIcon);
            arNotifyHeader.appendChild(arNotifyTitle);

            if (duration == 0) {
                arNotifyHeader.appendChild(arCloseBtn);
            }

            arNotifyContent.appendChild(arNotifyHeader);
        } else {
            if (duration == 0) {
                arNotifyBody.appendChild(arCloseBtn);
            }
            arNotifyBody.appendChild(arNotifyIcon);
        }

        arNotifyBody.appendChild(arNotifyMessage);

        arNotifyContent.appendChild(arNotifyBody);

        arNotify.appendChild(arNotifyContent);
        document.querySelector('body').appendChild(arNotify);

        if (duration > 0) {
            setTimeout(() => {
                arNotify.remove();
            }, duration);
        } else {
            arCloseBtn.addEventListener('click', () => {
                arNotify.remove();
            });
        }
    }

    decodeBase64Json(base64Str) {
        try {
            // Base64 解码为原始二进制字符串
            const binaryStr = atob(base64Str);

            // 转换为 Uint8Array
            const bytes = new Uint8Array(binaryStr.length);
            for (let i = 0; i < binaryStr.length; i++) {
                bytes[i] = binaryStr.charCodeAt(i);
            }

            // 使用 TextDecoder 解析 UTF-8 字符串
            const jsonStr = new TextDecoder('utf-8').decode(bytes);

            // 转换为对象
            return JSON.parse(jsonStr);
        } catch (err) {
            console.error("解码失败:", err);
            return null;
        }
    }

    /**
     * 类似 Vue 的 $emit，用原生 CustomEvent 触发
     * @param {string} eventName 事件名
     * @param {any} detail 事件数据
     */
    emit(eventName, detail) {
        this.dispatchEvent(new CustomEvent(eventName, {
            detail,
            bubbles: true,   // 允许事件冒泡（Vue 监听、jQuery 都能捕获）
            composed: true   // 跨 Shadow DOM 边界
        }));
    }
}

class AiReviewRuleBatchSetModalBtn extends BaseModalBtnClass {
    attributes = {
        btn_label: 'AI评阅设置',
        btn_class: '',
        btn_disabled: false,
        modal_title: '设置AI评阅应用',
        modal_class: '',
        question_ids: '',
        selected_option: '',
        submit_url: ''
    }

    btn_class = 'ar-rule-batch-set-btn';

    getBtnModalBodyHtml() {
        return `
        <div id="ar-rule-batch-set"></div>
        <div id="ar-rule-set-form-content" class="hide"></div>
        `;
    }

    getBtnModalFooterHtml() {
        return `
        <button type="button" class="ar-btn ar-cancel-btn">取消</button>
        <button type="button" class="ar-btn ar-btn-primary ar-submit-btn">确定</button>
        `;
    }

    loadAdditionalScript() {
        this.initAttributes();
        this.getRuleSetHtml().then(html => {
            this.querySelector('#ar-rule-batch-set').innerHTML = html;
        }).then(() => {
            this.querySelector('#review-rule').addEventListener('change', (opt) => {
                opt.target.parentElement.parentElement.parentElement.classList.remove('ar-form-item-error');
                opt.target.parentElement.parentElement.querySelector('.ar-form-item-error-text').innerHTML = '';

                let optId = opt.target.value;
                if (optId != '' && optId != 'customize') {
                    this.querySelector('#ar-rule-set-form-content').classList.add('hide');
                    this.querySelectorAll('div[id^="ar-rule-content-"]').forEach(function(item) {
                        item.classList.add('hide');
                    });
                    this.querySelector('#ar-rule-content-' + optId).classList.remove('hide');
                    this.querySelector('#ar-rule-batch-set-content').classList.remove('hide')
                } else {
                    this.querySelector('#ar-rule-batch-set-content').classList.add('hide');
                    this.querySelectorAll('div[id^="ar-rule-content-"]').forEach(function(item) {
                        item.classList.add('hide');
                    });
                    if (optId == 'customize') {
                        this.querySelector('#ar-rule-set-submit-type').value = 'customize_rule';
                        this.getRuleSetFormHtml().then(html => {
                            this.querySelector('#ar-rule-set-form-content').innerHTML = html;
                            this.querySelector('#ar-rule-set-form-content').classList.remove('hide');
                        });
                    } else {
                        this.querySelector('#ar-rule-set-form-content').classList.add('hide');
                    }
                }
            });

            this.querySelector('#ar-add-rule-btn').addEventListener('click', (opt) => {
                this.querySelector('#ar-rule-set-submit-type').value = 'create_rule';
                this.querySelector('#ar-rule-batch-set-title').classList.add('hide');
                this.querySelector('#ar-rule-batch-set-content').classList.add('hide');
                this.getRuleSetFormHtml(true).then(html => {
                    this.querySelector('#ar-rule-set-form-content').innerHTML = html;
                    this.querySelector('#ar-rule-set-form-content').classList.remove('hide');

                    let isTooltipVisible = false;
                    let tooltip = this.querySelector('#prompt-tooltip');
                    let tooltipBox = this.querySelector('#prompt-tooltip-box');
                    this.querySelector('#prompt-tooltip').addEventListener('click', (opt) => {
                        opt.stopPropagation(); // 阻止冒泡，防止触发 document 的点击事件
                        isTooltipVisible = !isTooltipVisible;
                        if (isTooltipVisible) {
                            const rect = tooltip.getBoundingClientRect();
                            tooltipBox.style.top = rect.top - 200 + 'px';
                            tooltipBox.style.left = rect.left + 80 + 'px';
                            tooltipBox.style.display = 'block';
                        } else {
                            tooltipBox.style.display = 'none';
                        }
                    });
                });
            });

            this.querySelector('.ar-submit-btn').addEventListener('click', (opt) => {
                let submitType = this.querySelector('#ar-rule-set-submit-type').value;
                let reviewRule = this.querySelector('#review-rule');

                if (submitType !== 'create_rule') {
                    if (!reviewRule.value) {
                        reviewRule.parentElement.parentElement.parentElement.classList.add('ar-form-item-error');
                        reviewRule.parentElement.parentElement.querySelector('.ar-form-item-error-text').innerHTML = '请选择AI评阅应用';
                        return false;
                    }
                }

                this.querySelectorAll('.ar-form-item').forEach(function(item) {
                    item.classList.remove('ar-form-item-error');
                });

                this.querySelectorAll('.ar-form-item .ar-form-item-error-text').forEach(function(item) {
                    item.innerHTML = '';
                });

                let name = this.querySelector('#ar-name');
                let prompt = this.querySelector('#ar-prompt');
                let model = this.querySelector('#ar-model');
                let temperature = this.querySelector('#ar-temperature');

                let formCheck = true;

                if (name && !name.value) {
                    name.parentElement.parentElement.classList.add('ar-form-item-error');
                    name.parentElement.querySelector('.ar-form-item-error-text').innerHTML = '请输入名称';
                    formCheck = false;
                }

                if (prompt && !prompt.value) {
                    prompt.parentElement.parentElement.classList.add('ar-form-item-error');
                    prompt.parentElement.querySelector('.ar-form-item-error-text').innerHTML = '请输入提示词';
                    formCheck = false;
                }

                if (model && !model.value) {
                    model.parentElement.parentElement.parentElement.classList.add('ar-form-item-error');
                    model.parentElement.parentElement.querySelector('.ar-form-item-error-text').innerHTML = '请选择模型';
                    formCheck = false;
                }

                if (temperature && (temperature.value === '' || parseFloat(temperature.value) > 1 || parseFloat(temperature.value) < 0)) {
                    temperature.parentElement.parentElement.classList.add('ar-form-item-error');
                    temperature.parentElement.querySelector('.ar-form-item-error-text').innerHTML = '请输入0-1之间的数字';
                    formCheck = false;
                }

                if (!formCheck) {
                    return false;
                }

                let csrfToken = '';
                if (document.querySelector('meta[name=csrf-token]')) {
                    csrfToken = document.querySelector('meta[name=csrf-token]').getAttribute('content');
                }

                let token = this.getCookie('TipDM-Login-Token');
                switch (submitType) {
                    case 'rule_id':
                        if (!this.attributes.submit_url) {
                            this.notify('error', '未配置保存评阅规则地址');
                            return false;
                        }

                        fetch(this.attributes.submit_url, {
                            method: 'POST',
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Content-Type': 'application/json',
                                'x-csrf-token': csrfToken,
                                'Authorization': 'Bearer ' + token,
                            },
                            body: JSON.stringify({
                                questionIds: this.attributes.question_ids,
                                applicationId: parseInt(reviewRule.value)
                            })
                        }).then(res => {
                            return res.json();
                        }).then(data => {
                            this.querySelector(".ar-modal").style.display = "none";
                            if (data.status !== 200) {
                                this.notify('error', '设置评阅规则失败');
                                return false;
                            }

                            let batchReviewBtn = document.querySelector('ar-batch-review-btn');
                            if (batchReviewBtn) {
                                batchReviewBtn.refresh();
                            }
                            this.notify('success', '设置评阅规则成功');
                        }).catch(error => {
                            this.querySelector(".ar-modal").style.display = "none";
                            this.notify('error', '设置评阅规则请求异常：' + error);
                            return false;
                        }).finally(() => {
                            this.emit('ar-rule-set-trigger');
                        });
                        break;
                    case 'customize_rule':
                        fetch('/customize_rule', {
                            method: 'POST',
                            body: {
                                questionIds: this.attributes.question_ids,
                                prompt: prompt,
                                model: model,
                                temperature: temperature
                            }
                        }).then(res => {
                            return res.json();
                        }).then(data => {
                            this.querySelector(".ar-modal").style.display = "none";
                            if (data.status !== 200) {
                                this.notify('error', '设置评阅规则失败');
                                return false;
                            }

                            this.notify('success', '设置评阅规则成功');
                        }).catch(error => {
                            this.querySelector(".ar-modal").style.display = "none";
                            this.notify('error', '设置评阅规则请求异常：' + error);
                            return false;
                        });
                        break;
                    case 'create_rule':
                        fetch(window.aiReviewConfig.apiService.host + '/api/application/public/' + window.aiReviewConfig.apiService.mark, {
                            method: 'POST',
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                username: 'ar_component',
                                userId: 0,
                                name: name.value,
                                prompt: prompt.value,
                                model: model.value,
                                temperature: temperature.value
                            })
                        }).then(res => {
                            return res.json();
                        }).then(data => {
                            if (data.status !== 200) {
                                this.notify('error', '创建评阅规则失败：' + data.message);
                                return false;
                            }

                            this.notify('success', '创建评阅规则成功');
                            this.refresh()
                        }).catch(error => {
                            this.querySelector(".ar-modal").style.display = "none";
                            this.notify('error', '创建评阅规则请求异常：' + error);
                            return false;
                        });
                        break;
                }
            });
        }).then(() => {
            if (this.attributes.selected_option != 0 && !this.attributes.selected_option.includes(',')) {
                this.querySelector('#review-rule').value = this.attributes.selected_option;
                this.querySelector('#review-rule').dispatchEvent(new Event('change', { bubbles: true }));
            } else {
                this.querySelector('#review-rule').value = '';
                this.querySelector('#review-rule').dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }
}

class AiReviewBatchReviewModalBtn extends BaseModalBtnClass {
    attributes = {
        btn_label: 'AI评阅',
        btn_class: '',
        btn_disabled: false,
        modal_title: 'AI评阅',
        modal_class: '',
        get_data_url: '',
    }

    btn_class = 'ar-batch-review-btn';

    getBtnModalBodyHtml() {
        return `
        <div id="ar-batch-review-content">
            <table class="ar-table">
                <thead>
                    <tr>
                        <th>题号</th>
                        <th style="width: 40%;">AI评阅应用</th>
                        <th>AI评阅进度</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
            <div><a id="ar-refresh" href="javascript:;">刷新数据</a></div>
        </div>
        `;
    }

    getBtnModalFooterHtml() {
        return `
        <div class="ar-complete-footer">
            <ar-complete-btn ar-btn-class="ar-btn-primary"></ar-complete-btn>
            <i class="warning-icon ar-mgl-10">i</i>
            <span>完成所有题目批阅后，点击”完成批阅”按钮完成整张答卷的批阅</span>
        </div>
        `;
    }

    loadAdditionalScript() {
        let csrfToken = '';
        if (document.querySelector('meta[name=csrf-token]')) {
            csrfToken = document.querySelector('meta[name=csrf-token]').getAttribute('content');
        }

        let token = this.getCookie('TipDM-Login-Token');
        fetch(this.attributes.get_data_url, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'x-csrf-token': csrfToken,
                'Authorization': 'Bearer ' + token,
            }
        }).then(res => {
            return res.json();
        }).then(data => {
            let tableBodyStr = '';
            let enableComplete = true;
            data.data.reviewList.forEach(function (item) {
                if (item.reviewNum < item.reviewSum) {
                    enableComplete = false;
                }

                let optStr = '<span class="ar-review-option-item"><ar-rule-batch-set-btn ar-btn-label="设置应用" ar-modal-title="设置AI评阅规则" ar-submit-url="' + item.setRuleUrl + '" ar-question-ids="' + item.questionId + '" ar-btn-class="ar-link-btn"></ar-rule-batch-set-btn></span>';
                let applicationStr = '';
                if (item.applicationId == 0) {
                    optStr += '<span class="ar-review-option-item">一键评阅</span>';
                } else {
                    optStr += '<span class="ar-review-option-item"><a href="javascript:;" class="ar-review-option-batch-review" data-url="' + item.reviewAllUrl + '">一键评阅</a></span>';
                    applicationStr = `<ar-rule-detail-btn ar-btn-label="` + item.applicationName + `" ar-btn-class="ar-link-btn" ar-data-json='` + item.applicationDataJson + `'></ar-rule-detail-btn>`;
                }

                if (item.reviewNum == 0) {
                    optStr += '<span class="ar-review-option-item">导出结果</span>';
                    optStr += '<span class="ar-review-option-item">一键应用</span>';
                } else {
                    optStr += '<span class="ar-review-option-item"><a href="javascript:;" class="ar-review-option-explore" data-url="' + item.exportUrl + '">导出结果</a></span>';
                    optStr += '<span class="ar-review-option-item"><a href="javascript:;" class="ar-review-option-save" data-url="' + item.acceptAllUrl + '">一键应用</a></span>';
                }

                tableBodyStr += `
                <tr>
                    <td><ar-question-detail-btn ar-btn-label="` + item.questionId + `" ar-btn-class="ar-link-btn" ar-data-json='` + item.questionDataJson + `'></ar-question-detail-btn></td>
                    <td>` + applicationStr + `</td>
                    <td>` + item.reviewNum + `/` + item.reviewSum + `</td>
                    <td><span class="ar-review-option">` + optStr + `</span></td>
                </tr>
                `;
            });

            this.querySelector('#ar-batch-review-content .ar-table tbody').innerHTML = tableBodyStr;

            this.querySelectorAll('.ar-review-option-batch-review').forEach(opt => opt.addEventListener('click', (opt_) => {
                let url = opt_.currentTarget.getAttribute('data-url');
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json',
                        'x-csrf-token': csrfToken,
                        'Authorization': 'Bearer ' + token,
                    }
                }).then(res => {
                    return res.json();
                }).then(data => {
                    if (data.status === 200) {
                        let message = data.message || '操作成功';
                        this.notify('success', message, 3000, '系统提示');
                    } else {
                        let message = data.message || '系统错误';
                        this.notify('error', message, 0, '系统提示');
                    }
                    this.querySelector(".ar-modal").style.display = "none";
                });
            }));

            this.querySelectorAll('.ar-review-option-explore').forEach(opt => opt.addEventListener('click', (opt_) => {
                window.open(opt_.currentTarget.getAttribute('data-url'));
            }));

            this.querySelectorAll('.ar-review-option-save').forEach(opt => opt.addEventListener('click', (opt_) => {
                if (confirm('若已进行评阅，AI评阅结果将覆盖原评阅结果。确定一键应用AI评阅结果?')) {
                    let url = opt_.currentTarget.getAttribute('data-url');
                    fetch(url, {
                        method: 'POST',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Content-Type': 'application/json',
                            'x-csrf-token': csrfToken,
                            'Authorization': 'Bearer ' + token,
                        }
                    }).then(res => {
                        return res.json();
                    }).then(data => {
                        if (data.status === 200) {
                            let message = data.message || '操作成功';
                            this.notify('success', message, 3000, '系统提示');
                        } else {
                            let message = data.message || '系统错误';
                            this.notify('error', message, 0, '系统提示');
                        }
                        this.querySelector(".ar-modal").style.display = "none";
                    });
                }
            }));

            if (!enableComplete) {
                this.querySelector('ar-complete-btn button').setAttribute('disabled', 'disabled');
            }
            this.querySelector('ar-complete-btn').setAttribute('ar-submit-url', data.data.submitUrl);

            this.querySelector('#ar-refresh').addEventListener('click', () => {
                this.refresh();
            });
        });
    }
}

class AiReviewReviewModalBtn extends BaseModalBtnClass {
    attributes = {
        btn_label: 'AI评阅',
        btn_class: '',
        btn_disabled: false,
        modal_title: 'AI评阅',
        modal_class: '',
        get_data_url: '',
    }

    btn_class = 'ar-review-btn';

    _modal_mask_transparent = true;

    getBtnModalBodyHtml() {
        return `
        <div class="ar-form-group">
            <div class="ar-form-item">
                <div class="ar-form-label"><label>AI评分</label></div>
                <div class="ar-form-content">
                    <div class="ar-form-content-text"></div>
                </div>
            </div>
            <div class="ar-form-item">
                <div class="ar-form-label"><label>AI评语</label></div>
                <div class="ar-form-content">
                    <div class="ar-form-content-text"></div>
                </div>
            </div>
        </div>
        `;
    }

    getBtnModalFooterHtml() {
        return `
        <button type="button" class="ar-btn ar-btn-primary ar-submit-btn">应用结果</button>
        `;
    }

    loadAdditionalScript() {
        let csrfToken = '';
        if (document.querySelector('meta[name=csrf-token]')) {
            csrfToken = document.querySelector('meta[name=csrf-token]').getAttribute('content');
        }

        let token = this.getCookie('TipDM-Login-Token');
        fetch(this.attributes.get_data_url, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'x-csrf-token': csrfToken,
                'Authorization': 'Bearer ' + token,
            }
        }).then(res => {
            return res.json();
        }).then(data => {
            if (Object.keys(data.data).length > 0) {
                this.querySelector('.ar-form-item:nth-child(1) .ar-form-content-text').innerHTML = data.data.reviewScore;
                this.querySelector('.ar-form-item:nth-child(2) .ar-form-content-text').innerHTML = data.data.reviewComment;
            }
            this.querySelector('.ar-modal-footer .ar-submit-btn').setAttribute('ar-submit-url', data.data.submitUrl);

            this.querySelector('.ar-submit-btn').addEventListener('click', (opt) => {
                let url = opt.currentTarget.getAttribute('ar-submit-url');
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json',
                        'x-csrf-token': csrfToken,
                        'Authorization': 'Bearer ' + token,
                    }
                }).then(res => {
                    return res.json();
                }).then(data => {
                    if (data.status === 200) {
                        let message = data.message || '操作成功';
                        this.notify('success', message, 3000);
                    } else {
                        let message = data.message || '系统错误';
                        this.notify('error', message, 0);
                    }
                    this.querySelector(".ar-modal").style.display = "none";
                }).finally(() => {
                    this.emit('ar-review-trigger');
                });
            });
        });
    }
}

class AiReviewQuestionDetailModalBtn extends BaseModalBtnClass {
    attributes = {
        btn_label: '题目预览',
        btn_class: '',
        btn_disabled: false,
        modal_title: '题目预览',
        modal_class: '',
        data_url: '',
        data_json: '',
    }

    btn_class = 'ar-question-detail-btn';

    loadAdditionalScript() {
        let questionData = this.decodeBase64Json(this.attributes.data_json);

        let questionFormHtml = '';
        let questionFormFooterHtml = '';
        let questionAnswerHtml = '';
        let questionStemHtml = questionData.stem;
        let questionAnalysisHtml = questionData.analysis;

        if (!questionAnalysisHtml) {
            questionAnalysisHtml = '<p>无解析</p>';
        }

        let optIndex = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        let optStr = '';
        let selectOptStr = '';

        switch (questionData.type) {
            case 'essay':
            case 'subjectivity':
                questionFormHtml = '<textarea rows="1" class="ar-form-control"></textarea>';
                questionAnswerHtml = '<p>参考答案</p>' + questionData.answer;
                break;
            case 'single_choice':
                questionData.metas.choices.forEach(function (item, index) {
                    optStr += '<li class="ar-question-form-option"><span>' + optIndex[index] + '.</span><p>' + item + '</p></li>';
                    selectOptStr += '<label class="ar-question-form-selector"><input type="radio" name="question_' + questionData.id + '">' + optIndex[index] + '</label>';
                });
                questionFormHtml = `
                <ul>
                    ${optStr}
                </ul>
                `;

                questionFormFooterHtml = selectOptStr;
                questionAnswerHtml = '正确答案是 ' + '<strong>' + optIndex[questionData.answer[0]] + '</strong>';
                break;
            case 'choice':
            case 'uncertain_choice':
                questionData.metas.choices.forEach(function (item, index) {
                    optStr += '<li class="ar-question-form-option"><span>' + optIndex[index] + '.</span><p>' + item + '</p></li>';
                    selectOptStr += '<label class="ar-question-form-selector"><input type="checkbox" name="question_' + questionData.id + '">' + optIndex[index] + '</label>';
                });
                questionFormHtml = `
                <ul>
                    ${optStr}
                </ul>
                `;

                questionData.answer.forEach(function (item, index) {
                    if (!questionAnswerHtml) {
                        questionAnswerHtml = optIndex[index]
                    } else {
                        questionAnswerHtml += ',' + optIndex[index];
                    }
                });

                questionFormFooterHtml = selectOptStr;
                questionAnswerHtml = '正确答案是 ' + '<strong>' + questionAnswerHtml + '</strong>';
                break;
            case 'fill':
                let answerArray = questionStemHtml.match(/\[\[.+?\]\]/ig);
                if (answerArray) {
                    answerArray.forEach(function (item, index) {
                        questionStemHtml = questionStemHtml.replace(item, '<span class="ar-question-stem-fill-blank">(' + (index + 1) + ')</span>');
                    })
                }
                questionStemHtml = '<div>' + questionStemHtml + '</div>';

                questionData.answer.forEach(function (item, index) {
                    let answerItem = '';
                    item.forEach(function (item) {
                        if (!answerItem) {
                            answerItem = '<strong>' + item + '</strong>';
                        } else {
                            answerItem += ' 或 ' + '<strong>' + item + '</strong>';
                        }
                    })
                    questionFormHtml += '<input type="text" class="ar-form-control ar-mgb-10" placeholder="填空(' + (index + 1) + ')答案，请填在这里">';
                    questionAnswerHtml += '<div>填空(' + (index + 1) + ')：正确答案 ' + answerItem + '</div>';
                });
                break;
            case 'determine':
                let answerMap = ['正确', '错误'];
                answerMap.forEach(function (item, index) {
                    selectOptStr += '<label class="ar-question-form-selector"><input type="radio" name="question_' + questionData.id + '">' + answerMap[index] + '</label>';
                });

                questionFormFooterHtml = selectOptStr;
                questionAnswerHtml = '正确答案是 ' + '<strong>' + answerMap[questionData.answer[0]] + '</strong>';
                break;
        }

        let body = `
        <div class="ar-question-body">
            <div class="ar-question-score">` + parseFloat(questionData.score).toFixed(1) + `分</div>
            <div class="ar-question-stem">` + questionStemHtml + `</div>
        </div>
        <div class="ar-question-form">` + questionFormHtml + `</div>
        <div class="ar-question-form-footer">` + questionFormFooterHtml + `</div>
        <div class="ar-question-answer">` + questionAnswerHtml + `</div>
        <div class="ar-question-analysis">` + questionAnalysisHtml + `</div>
        `;

        this.setModalTitleHtml('题目预览');
        this.setModalBodyHtml(body);
        this.setModalFooterHtml('<button type="button" class="ar-btn ar-cancel-btn">关闭</button>');
        this.showModal();
    }
}

class AiReviewRuleDetailModalBtn extends BaseModalBtnClass {
    attributes = {
        btn_label: '应用预览',
        btn_class: '',
        btn_disabled: false,
        modal_title: '应用预览',
        modal_class: '',
        data_json: '',
    }

    btn_class = 'ar-rule-set-detail-btn';

    loadAdditionalScript() {
        let ruleData = this.decodeBase64Json(this.attributes.data_json);

        let body = `
        <div class="ar-form-group" id="ar-rule-content-` + ruleData.id + `">
            <div class="ar-form-item">
                <div class="ar-form-label"><label>名称</label></div>
                <div class="ar-form-content">
                    <div class="ar-form-content-text">` + ruleData.name + `</div>
                    <p class="ar-form-item-error-text"></p>
                </div>
            </div>
            <div class="ar-form-item">
                <div class="ar-form-label"><label>提示词</label></div>
                <div class="ar-form-content">
                    <div class="ar-form-content-text">` + ruleData.prompt.replace(/\n/gm,"<br/>") + `</div>
                    <p class="ar-form-item-error-text"></p>
                </div>
            </div>
            <div class="ar-form-item">
                <div class="ar-form-label"><label>模型</label></div>
                <div class="ar-form-content">
                    <div class="ar-form-content-text">` + ruleData.model + `</div>
                    <p class="ar-form-item-error-text"></p>
                </div>
            </div>
            <div class="ar-form-item">
                <div class="ar-form-label"><label>温度</label></div>
                <div class="ar-form-content">
                    <div class="ar-form-content-text">` + ruleData.temperature + `</div>
                    <p class="ar-form-item-error-text"></p>
                </div>
            </div>
        </div>
        `;

        this.setModalTitleHtml('应用预览');
        this.setModalBodyHtml(body);
        this.setModalFooterHtml('<button type="button" class="ar-btn ar-cancel-btn">关闭</button>');
        this.showModal();
    }
}

class AiReviewCompleteBtn extends BaseModalBtnClass {
    attributes = {
        btn_label: '完成批阅',
        btn_class: '',
        btn_disabled: false,
        modal_title: '完成批阅',
        modal_class: '',
        data_json: '',
    }

    btn_class = 'ar-complete-btn';

    _modal_block = true;

    loadAdditionalScript() {
        let submitUrl = this.getAttribute('ar-submit-url');

        let csrfToken = '';
        if (document.querySelector('meta[name=csrf-token]')) {
            csrfToken = document.querySelector('meta[name=csrf-token]').getAttribute('content');
        }

        let token = this.getCookie('TipDM-Login-Token');
        fetch(submitUrl, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json',
                'x-csrf-token': csrfToken,
                'Authorization': 'Bearer ' + token,
            }
        }).then(res => {
            return res.json();
        }).then(data => {
            if (data.status === 200) {
                let message = data.message || '操作成功';
                this.notify('success', message, 3000);
            } else {
                let message = data.message || '系统错误';
                this.notify('error', message, 0);
            }
        }).finally(() => {
            this.emit('ar-complete-trigger');
        });
    }
}

let globalCss = `
<style>
    /**
    通用样式
     */
    *, :after, :before {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    input::placeholder, textarea::placeholder {
        color: #ccc !important;
    }

    .ar-modal {
        display: none;
        position: fixed;
        overflow: hidden;
        z-index: 99999;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.4);
    }
    
    .ar-modal-min .ar-modal-content {
        width: 400px;
    }
    
    .ar-modal-content {
        display: flex;
        flex-direction: column;
        position: relative;
        background-color: #fefefe;
        margin: 80px auto;
        border: 1px solid #c3c3c3;
        width: 800px;
        border-radius: 4px;
        animation: modalDown 0.4s;
    }
    
    @keyframes modalDown {
        from {top: -50px; opacity: 0}
        to {top: 0; opacity: 1}
    }
    
    .ar-modal-header {
        align-items: center;
        padding: 10px 20px;
        border-bottom: 1px solid #3333;
        background-color: #f2f3f5;
        border-radius: 4px 4px 0 0;
        cursor: move;
    }
    
    .ar-modal-body {
        color: #616161;
        font-size: 14px;
        padding: 24px 10px;
        max-height: 680px;
        overflow-y: auto;
    }
    
    .ar-modal-footer {
        padding: 10px 20px;
        text-align: right;
    }
    
    .ar-modal-footer .ar-btn {
        margin-left: 10px;
    }
    
    .ar-modal-title {
        font-size: 18px;
        line-height: 18px;
        color: #1d2129;
    }
    
    .ar-close-btn {
        color: #aaa;
        float: right;
        font-size: 20px;
        font-weight: bold;
    }
    
    .ar-close-btn:hover {
        color: black;
        text-decoration: none;
        cursor: pointer;
    }

    @keyframes notifyDown {
        from {top: 60px; opacity: 0}
        to {top: 100px; opacity: 1}
    }

    .ar-notify {
        z-index: 999999;
        position: fixed;
        width: 360px;
        left: calc(50% - 180px);
        top: 100px;
        border: 1px solid #efefef;
        border-radius: 8px;
        background-color: #fefefe;
        animation: notifyDown 0.4s;
    }
    
    .ar-notify-header {
        align-items: center;
        padding: 10px 16px 0px 40px;
        font-size: 1.2em;
        font-weight: 600;
    }
    
    .ar-notify-title {
        top: 3px;
        position: relative;
    }
    
    .ar-notify-body {
        padding: 20px 16px 20px 40px;
    }
    
    .ar-notify-icon {
        position: absolute;
        left: 8px;
    }
    
    .ar-notify-message {
        display: flex;
        padding-right: 6px;
        word-wrap: break-word; 
        word-break: break-all;
    }
    
    .ar-form-label {
        display: inline-block;
        text-align: right;
        width: 70px;
        padding-right: 10px;
        vertical-align: top;
        line-height: 34px;
        position: relative;
    }
    
    .ar-form-label-require {
        position: relative;
    }
    
    .ar-form-label-require:before {
        content: "*";
        color: #ff1f26;
        position: relative;
        left: -6px;
    }
    
    .ar-form-item-error .ar-form-label {
        color: #ff1f26;
    }
    
    .ar-form-item-error .ar-form-control {
        border-color: #ff1f26;
    }
    
    .ar-form-item-error-text {
        color: #ff1f26;
    }
    
    .ar-form-content {
        display: inline-block;
        width: 100%;
        vertical-align: middle;
    }
    
    .ar-form-content-text {
        padding: 6px;
        word-wrap: break-word; 
        word-break: break-all;
    }
    
    .ar-form-control {
        width: 100%;
        padding: 6px 12px;
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: 4px;
        outline: none;
    }
    
    .ar-form-item {
        margin-bottom: 16px;
        display: flex;
    }
    
    .hide {
        display: none !important;
    }
    
    .ar-btn {
        display: inline-block;
        text-align: center;
        touch-action: manipulation;
        cursor: pointer;
        white-space: nowrap;
        user-select: none;
        line-height: 1em;
        font-weight: 500;
        padding: 9px 14px;
        background: #fff;
        color: #606266;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
    }
    
    .ar-btn-primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
    }
    
    .ar-btn-primary.is-plain {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
    }
    
    .ar-btn-warning {
        color: #fff;
        background-color: #e6a23c;
        border-color: #e6a23c;
    }
    
    .ar-btn-warning.is-plain {
        color: #e6a23c;
        background: #fdf6ec;
        border-color: #f5dab1;
    }
    
    .ar-btn-danger {
        color: #fff;
        background-color: #f56c6c;
        border-color: #f56c6c;
    }
    
    .ar-btn-danger.is-plain {
        color: #f56c6c;
        background: #fef0f0;
        border-color: #fbc4c4;
    }
    
    .ar-link-btn {
        border: none;
        color: #409eff;
        padding: 0;
    }
    
    .ar-btn:disabled {
        opacity: .4;
        cursor: not-allowed;
    }
    
    .ar-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
    }
    
    .ar-table th, .ar-table td {
        padding: 6px;
        text-align: left;
    }
    
    .ar-table th {
        font-weight: bold;
    }
    
    .ar-tooltip {
        display: inline-block;
    }
    
    .ar-tooltip-trigger {
        color: #409eff;
        cursor: pointer;
        user-select: none;
    }
    
    .ar-mgb-10 {
        margin-bottom: 10px;
    }
    
    .ar-mgl-10 {
        margin-left: 10px;
    }
    
    .ar-mgl-20 {
        margin-left: 20px;
    }
    
    .ar-mg-10 {
        margin: 10px !important;
    }
    
    .ar-float-right {
        float: right !important;
    }
    /**
    特定样式
     */
    ar-rule-batch-set-btn, ar-batch-review-btn {
        display: inline-block;
    }
     
    #ar-rule-batch-set-content {
        margin-top: 12px;
        padding: 8px 16px;
        background-color: #efefef;
        max-height: 540px;
        overflow-y: auto;
    }
    
    #ar-rule-set-form-content {
        margin-top: 20px;
        max-height: 540px;
        overflow-y: auto;
    }

    .ar-rule-set-selector {
        display: inline-block;
        width: 400px;
        margin-right: 30px;
    }
    
    .ar-review-option-item {
        margin-right: 12px;
        color: #b9b9b9;
    }

    #ar-batch-review-content a {
        text-decoration: none;
        color: #409eff;
    }

    .ar-question-score {
        font-size: 12px;
        color: #aaa;
        border: 1px solid #ccc;
        padding: 0 1px;
        border-radius: 5px;
        background: #f6f6f6;
        float: left;
        width: 40px;
        margin: 0 10px;
        text-align: center;
    }
    
    .ar-question-stem {
        margin-bottom: 10px;
        border-bottom: 1px dashed #ddd;
        overflow: hidden;
        zoom: 1;
    }

    .ar-question-stem-fill-blank {
        padding: 0 15px;
        border-bottom: 1px solid #999;
        color: #aaa;
    }

    .ar-question-form {
        margin-left: 60px;
    }
    
    .ar-question-form-footer {
        margin-left: 60px;
    }
    
    .ar-question-answer {
        margin: 20px 0 20px 60px;
    }
    
    .ar-question-analysis {
        padding: 19px;
        margin-left: 60px;
        background-color: #fafafa;
        border: 1px solid #f5f5f5;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
    }
    
    .ar-question-form ul {
        padding-left: 0;
        list-style: none;
        border-bottom: 1px dashed #ddd;
        padding-bottom: 10px;
    }
    
    .ar-question-form-option {
        width: 100%;
        padding: 4px;
    }
    
    .ar-question-form-option:hover {
        background-color: #f5f5f5;
        cursor: pointer;
    }
    
    .ar-question-form-option p {
        margin: 0 0 0 20px;
        display: inline-block;
    }
    
    .ar-question-form-selector {
        padding: 8px 20px 8px 30px;
        display: inline-block;
    }
    
    .ar-question-form-selector:hover {
        background-color: #f5f5f5;
        cursor: pointer;
    }
    
    .ar-question-form-selector input {
        position: absolute;
        margin-left: -20px;
    }
    
    .ar-complete-footer {
        font-size: 14px;
        text-align: left;
    }
    
    .warning-icon {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: #409eff;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: bold;
        font-size: 12px;
        font-style: normal;
        display: inline-flex;
    }
    
    #prompt-tooltip-box {
      position: fixed;
      padding: 6px 10px;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      font-size: 14px;
      white-space: nowrap;
      background-color: #ffffff;
      z-index: 999;
      display: none;
      transform-origin: left center;
    }
    
    .ar-vue-button {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-color: #dcdfe6;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        -webkit-transition: .1s;
        transition: .1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 12px 20px;
        font-size: 14px;
        border-radius: 4px;
        margin-left: 10px;
    }
    
    .ar-vue-button-primary {
        color: #fff;
        background-color: #0070de;
        border-color: #0070de;
    }
    
    .ar-vue-button-mini {
        padding: 7px 15px;
        font-size: 12px;
        border-radius: 3px;
    }
    
    .ar-vue-button-small {
        padding: 9px 15px;
        font-size: 12px;
        border-radius: 3px;
    }
</style>
`;

window.customElements.define('ar-rule-batch-set-btn', AiReviewRuleBatchSetModalBtn);
window.customElements.define('ar-batch-review-btn', AiReviewBatchReviewModalBtn);
window.customElements.define('ar-review-btn', AiReviewReviewModalBtn);
window.customElements.define('ar-question-detail-btn', AiReviewQuestionDetailModalBtn);
window.customElements.define('ar-rule-detail-btn', AiReviewRuleDetailModalBtn);
window.customElements.define('ar-complete-btn', AiReviewCompleteBtn);
